import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'detail',
    component: () => import('@/components/detail')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/components/home')
  },
  {
    path: '/:id',
    name: 'detail',
    component: () => import('@/components/detail')
  }
]

// 创建路由实例
const router = new Router({
  mode: 'history', // 使用 HTML5 History 模式，去掉 URL 中的 #，可选
  base: process.env.BASE_URL,
  routes
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js